export default {
  dark: 'Темная',
  light: 'Светлая',
};
